import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateSystemSalaryEntity } from '../../domain/entities/CreateUpdateSystemSalary'
import { SalarySystemType } from '../../domain/enums/SalarySystemType'

export class CreateUpdateSystemSalaryModel extends CreateUpdateSystemSalaryEntity {
  constructor(dataDto: CreateUpdateSystemSalaryEntity) {
    super()
    mapEntityProperties<CreateUpdateSystemSalaryModel>(this, dataDto, {
      map: {
        perDirectDistance:
          dataDto.type === SalarySystemType.PER_DIRECT_DISTANCE
            ? dataDto.perDirectDistance
            : undefined,
        perRouteDistance:
          dataDto.type === SalarySystemType.PER_ROUTE_DISTANCE
            ? dataDto.perRouteDistance
            : undefined,
        perDirectDistanceSegment:
          dataDto.type === SalarySystemType.PER_DIRECT_DISTANCE_SEGMENT
            ? dataDto.perDirectDistanceSegment
            : undefined,
        perRouteDistanceSegment:
          dataDto.type === SalarySystemType.PER_ROUTE_DISTANCE_SEGMENT
            ? dataDto.perRouteDistanceSegment
            : undefined
      }
    })
  }
}
